import Splide from '@splidejs/splide';
import { gsap } from 'gsap';

var sliders = document.querySelectorAll('.hero-third-scene .splide');
var arrow = document.querySelector('.animated-arrow');
var animatedArrows = document.querySelectorAll('.animated-arrow use');
var arrowSize = arrow.clientWidth;

configure();
window.addEventListener('resize', configure)
sliders.forEach(element => {
    var slider = new Splide(element, {
        type: 'fade',
        perPage: 1,
        gap: 0,
        speed: 0,
        breakpoints: {
            767: {
                destroy: true
            }
        }
    }).mount();
    slider.on('active', function (e) {
        activeSliderHandler(e.slide);
    }).on('moved', function (newIndex, oldIndex) {
        if (newIndex !== oldIndex) {
            var target = newIndex > oldIndex ? this.querySelector('.splide__arrow--next') : this.querySelector('.splide__arrow--prev');
            if (!target.classList.contains('animate')) {
                target.classList.add('animate');
                setTimeout(() => {
                    target.classList.remove('animate');
                }, 1600);
            }
        }
    }.bind(element));
});

function configure() {
    if (arrow.clientWidth !== arrowSize) {
        arrowSize = arrow.clientWidth;
        animatedArrows.forEach(self => {
            self.setAttribute('href', arrowSize < 60 ? '#smallCircle' : '#circle');
        });
    }
}


function activeSliderHandler(slide) {
    var previousTimeline = gsap.timeline();
    var links = slide.querySelectorAll('.hero-third-scene__grid-item > a');
    if (links.length) {
        previousTimeline
            .fromTo(links[0], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '+=0.3');
        if (links[1]) {
            previousTimeline.fromTo(links[1], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }

        if (links[3]) {
            previousTimeline.fromTo(links[3], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }

        if (links[2]) {
            previousTimeline.fromTo(links[2], 0.8, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1
            }, '-=.6');
        }
    }
}
